import { Config, Integrations } from '@/types/Config';
import { Feature, Features } from '@/types/Features';
import { Permissions } from '@/types/Permissions';
import { get } from 'lodash';
import { reactive } from 'vue';
import serverAPI from '../serverAPI';

export enum FeatureFlag {
  PROFIT_MODE = 'profitMode',
  SALESFORCE_CLIENT_NAME_RESOLUTION = 'salesforceClientNameResolution',
  SALESFORCE_FAMILY_NAME_RESOLUTION = 'salesforceFamilyNameResolution',
  BANKER_NAME_RESOLUTION = 'bankerNameResolution',
  OPPORTUNITIES = 'opportunities',
  BONUS_CALCULATOR = 'bonusCalculator',
  MAINTENANCE_MODE = 'maintenanceMode',
  VIEW_HISTORIC = 'viewHistoric',
  FAMILY_LEVEL_SIMULATED_IMPACT = 'familyLevelSimulatedImpact',
  TARGETS = 'targets',
  SALES_CHURN_MODE = 'salesChurnMode',
  LEADS = 'leads',
  LINK_CLIENTS = 'linkClients',
  INTERMEDIARIES = 'intermediaries',
  SALES_PIPELINE = 'salesPipeline',
}

export enum PermissionType {
  CAN_CREATE_PROSPECTS = 'canCreateProspects',
}

export let config: Config = {} as Config;
export let features: Features = reactive({} as Features);
export let permissions: Permissions = reactive({} as Permissions);

export const setGlobalIntegrations = async () => {
  const integrationsRequest = await serverAPI.get('/integrations');
  return new Promise<Integrations>(resolve => {
    config = { ...config, ...integrationsRequest };
    resolve(config.integrations);
  });
};

export const setGlobalConfig = async () => {
  const configRequest = await serverAPI.get('/config');
  return new Promise<Config>(resolve => {
    config = { ...config, ...configRequest };
    resolve(config);
  });
};

export const setGlobalFeatureFlags = async () => {
  const featureRequest = await serverAPI.get('/features');
  return new Promise<Features>(resolve => {
    features = featureRequest.features;
    resolve(features);
  });
};

export const setUserPermissions = async () => {
  const permissionsRequest = await serverAPI.get('/users/permissions');
  return new Promise<Permissions>(resolve => {
    permissions = permissionsRequest;
    resolve(permissions);
  });
};

export const getConfig = (key: string) => {
  key = `config.${key}.value`;
  const configItem = get(config, key, null);
  if (configItem === 'true') {
    return true;
  } else if (configItem === 'false') {
    return false;
  } else {
    return configItem;
  }
};

export const getTranslations = () => {
  const t = get(config, 'translations', null);
  return t;
};

export const getFeatureFlag = (key: FeatureFlag) => {
  const featureFlag = get(features, key, {}) as Feature;
  return featureFlag;
};

export const getPermission = (key: PermissionType) => {
  const permission = get(permissions, key, false) as boolean;
  return permission;
};

export const getIntegration = (key: string) => {
  key = `integrations.${key}`;
  const configItem = get(config, key, null);
  if (configItem === 'true') {
    return true;
  } else if (configItem === 'false') {
    return false;
  } else {
    return configItem;
  }
};
